export interface IAisParams {
  working_radius: number
  risk_radius: number
  safety_zb: number
  safety_zt: number
  projection_period: number
  projection_duration: number
}


export const getDefaultAisParams = (): IAisParams => {
  return {
    working_radius: 10,
    risk_radius: 0.5,
    safety_zb: 50,
    safety_zt: 2,
    projection_period: 5,
    projection_duration: 60,    
  }
}
